import config from "../../config/config";
import { getToken } from "../../lib";


function getHeaders() {
  return {
    "Authenticity-Token": getToken(),
    Accept: "application/json",
    "Content-Type": "application/json",
  }
}


export function addQuestionnaire(data) {
  return fetch(`${config.URI}/api/v1/questionnaire`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

export function updateQuestionnaire(data) {
  return fetch(`${config.URI}/api/v1/questionnaire/${data.id}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

export function deleteQuestionnaire(id) {
  return fetch(`${config.URI}/api/v1/questionnaire/${id}`, {
    method: "DELETE",
    headers: getHeaders(),
  }).then((res) => res.json);
}

export function updateTemplate(data) {
  return fetch(`${config.URI}/api/v1/template/${data.id}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

export function deleteTemplate(id) {
  return fetch(`${config.URI}/api/v1/template/${id}`, {
    method: "DELETE",
    headers: getHeaders(),
  }).then((res) => res.json);
}


// WEBPACK FOOTER //
// src/components/Questionnaire/actions.js